class HomeSlider extends HTMLElement{
    constructor(){
        super();
        this.counter = 1;

        this.isDragging = false;
        this.dif = null;
        this.start = 0;
        this.transform = 0;

        this.slide = this.querySelector(".slide");
        this.items = this.querySelectorAll(".slide-item");
        this.next = this.querySelector("#NextBtn");
        this.prev = this.querySelector("#PrevBtn");
        
        const cloneFirst = this.slide.firstElementChild.cloneNode(true);
        const cloneLast = this.slide.lastElementChild.cloneNode(true);

        this.slide.append(cloneFirst);
        this.slide.prepend(cloneLast);

        this.slide.style.transition = "none";
        this.slide.style.transform = `translateX(-${ this.counter * 100}vw)`;

        this.next.addEventListener("click", this.nextSlide.bind(this));
        this.prev.addEventListener("click", this.prevSlide.bind(this));
        this.slide.addEventListener("pointerdown", this.pointerStart.bind(this));
        this.slide.addEventListener("pointermove", this.pointerMove.bind(this));
        this.slide.addEventListener("pointerup", this.pointerUp.bind(this));

        this.timer = setInterval(() => {
            this.counter++;
            this.slide.style.transition = "all 0.5s";
            this.slide.style.transform = `translateX(-${this.counter * 100}vw)`;
            if(this.counter >= this.items.length + 1){
                setTimeout(()=>{
                    this.counter = 1;
                    this.slide.style.transition = "none";
                    this.slide.style.transform = `translateX(-${this.counter * 100}vw)`;
                },500)    
            }
        }, 8000);
    }

    nextSlide(){
        this.counter++;
        this.slide.style.transition = "all 0.5s";
        this.slide.style.transform = `translateX(-${this.counter * 100}vw)`;
        if(this.counter >= this.items.length + 1){
            setTimeout(()=>{
                this.counter = 1;
                this.slide.style.transition = "none";
                this.slide.style.transform = `translateX(-${this.counter * 100}vw)`;
            },500)    
        }
        clearInterval(this.timer);
    }
    prevSlide(){
        this.counter--;
        this.slide.style.transition = "all 0.5s";
        this.slide.style.transform = `translateX(-${this.counter * 100}vw)`;
        if(this.counter <= 0){
            setTimeout(()=>{
                this.counter= this.items.length;
                this.slide.style.transition = "none";
                this.slide.style.transform = `translateX(-${this.counter * 100}vw)`;
            },500) 
        }
        clearInterval(this.timer);
    }
    pointerStart(e){
        this.isDragging = true;
        this.start = e.pageX;
        const matrixTransform = window.getComputedStyle(this.slide).transform;
        if(matrixTransform !== "none") this.transform = parseInt(matrixTransform.split(",")[4].trim());
        console.log(this.start)
    }
    pointerMove(e){
        if(this.isDragging){
            this.dif = e.pageX - this.start;
            console.log(this.dif, e.pageX, this.start)
            this.slide.style.transform = `translateX(${this.dif + this.transform}px)`;
        }
    }

    pointerUp(){
        if(this.isDragging){
            this.isDragging = false;
            if(this.dif < -35){
               this.dif = null;
               this.counter++;
               this.slide.style.transition = "all 0.5s";
               this.slide.style.transform = `translateX(-${100 * this.counter}vw)`;
               console.log(this.counter)
               if(this.counter >= this.items.length + 1){
                   setTimeout(()=>{
                        this.counter = 1;
                        this.slide.style.transition = "none";
                        this.slide.style.transform = `translateX(-${100 * this.counter}vw)`;
                   }, 500);
               }
               clearInterval(this.timer);
            }
            if(this.dif > 35){
               this.dif = null;
               this.counter--;
               this.slide.style.transition = "all 0.5s";
               this.slide.style.transform = `translateX(-${100 * this.counter}vw)`;
               console.log(this.counter)
               if(this.counter == 0){
                   setTimeout(()=>{
                        this.counter = this.items.length;
                        this.slide.style.transition = "none";
                        this.slide.style.transform = `translateX(-${100 * this.counter}vw)`;
                    }, 500);
                }
                clearInterval(this.timer);
            }
            if(this.dif <= 35 && this.dif >= -35){
               this.dif = null;
               this.slide.style.transition = "all 0.5s";
               this.slide.style.transform = `translateX(-${100 * this.counter}vw)`;
               clearInterval(this.timer);
            }
        }
    }
}

window.customElements.define("home-slider", HomeSlider)
